import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type AssignmentsRoute from 'teacher-ui-client/assignments/route'
import type AssignmentsProductRoute from 'teacher-ui-client/assignments/product/route'
import type AssignmentsManageDataService from 'teacher-ui-client/services/assignments-admin/manage-data'

export default class extends Route {
  @service('assignments-admin/manage-data') assignmentsManageData!: AssignmentsManageDataService

  queryParams = {
    pageNumber: {
      refreshModel: true,
      replace: true,
    },
    perPage: {
      refreshModel: true,
      replace: true,
    },
    sortColumn: {
      refreshModel: true,
      replace: true,
    },
    sortDirection: {
      refreshModel: true,
      replace: true,
    },
    selectedAssignmentId: {
      replace: true,
    },
  }

  async model(params: { pageNumber: number; perPage: number; sortDirection: string; sortColumn: string }) {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const { students } = (this.modelFor('assignments') as ModelFor<AssignmentsRoute>) ?? {
      students: [],
    }
    const { assignmentProduct: product } = this.modelFor('assignments.product') as ModelFor<AssignmentsProductRoute>
    const assignmentsData = await this.assignmentsManageData.forPastAssignments({
      sortingAndPagination: {
        page: params.pageNumber,
        perPage: params.perPage,
        sortDirection: params.sortDirection,
        sortColumn: params.sortColumn,
      },
      product,
    })
    return { ...assignmentsData, students, subscriptionType }
  }
}
